import Toggle from 'legacy/common/components/form/Toggle';
import InfoTooltip from 'legacy/common/components/wysiwyg-form/InfoTooltip';
import Tooltip from 'legacy/common/components/wysiwyg-form/Tooltip';
import React from 'react';
import classNames from 'classnames';

export enum OptionType {
  Button = 'button',
  Toggle = 'toggle'
}
interface SettingsOptionProps {
  icon: React.ReactNode;
  title: string;
  actionLabel?: string;
  type?: OptionType;
  isActive?: boolean;
  value?: string;
  disabled?: boolean;
  tooltipMessage?: string;
  disabledTooltipMessage?: string;
  onClick?: () => void;
}

/**
 * This component should have better composability.
 * TODO: Transform this into a compound component
 */
const SettingsOption: React.FC<SettingsOptionProps> = ({
  icon,
  title,
  type = OptionType.Button,
  isActive,
  value,
  actionLabel,
  disabled,
  tooltipMessage,
  disabledTooltipMessage,
  onClick
}) => (
  <div
    className={classNames(
      'flex items-center justify-between px-4 py-5 border-1 border-gray-300 rounded-lg mt-4',
      disabled ? 'bg-neutral-100 cursor-default' : 'cursor-pointer'
    )}
    onClick={() => {
      if (disabled) {
        return;
      }

      onClick?.();
    }}
  >
    <div className="flex items-center">
      {icon}
      <span className="ml-2 text-base">{title}</span>
      {tooltipMessage && (
        <InfoTooltip id={`${title}-tooltip`} message={tooltipMessage} />
      )}
    </div>

    {type === OptionType.Toggle && (
      <>
        <div data-tip data-for={`${title}-disabled-tooltip`}>
          <Toggle isActive={isActive} disabled={disabled} />
        </div>
        {disabledTooltipMessage && disabled && (
          <Tooltip
            place="right"
            effect="solid"
            id={`${title}-disabled-tooltip`}
            message={disabledTooltipMessage}
          />
        )}
      </>
    )}

    {type === OptionType.Button && (
      <button
        type="button"
        className="max-w-[150px] md:max-w-sm text-sm text-primary-400 font-semibold text-right whitespace-nowrap text-ellipsis overflow-hidden"
        disabled={disabled}
      >
        {value ? (
          <span className="font-normal text-gray-500">{value}</span>
        ) : (
          <span>+ {actionLabel}</span>
        )}
      </button>
    )}
  </div>
);

export default SettingsOption;
